<template>
  <div>
    <g-meta-tags v-if="state.story.content.seo" :meta="state.story.content.seo[0]" />

    <component
      :is="components[state.story.content.component]"
      :title="state.story.name"
      :blok="state.story.content"
      v-editable="state.story.content"
    />

    <g-footer />
  </div>
</template>

<script setup>
import { onMounted, defineAsyncComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import { useStoryblokBridge, useStoryblokApi } from "@storyblok/vue";
import { useSetGlobals } from "@/composables/useGlobals.js";
import getCv from "@/auto-generated/cv.json";
import prebuildConfig from "@/auto-generated/prebuild-config.json";
import GMetaTags from "@/components/00-global/g-meta-tags.vue";
import GFooter from "@/components/00-global/g-footer.vue";

const props = defineProps({
  slug: String,
});

// Register async template components from Storyblok
const components = {
  "t-global-config": defineAsyncComponent(() => import("@/components/05-templates/t-global-config.vue")),
  "t-default": defineAsyncComponent(() => import("@/components/05-templates/t-default.vue")),
  "t-case": defineAsyncComponent(() => import("@/components/05-templates/t-case.vue")),
  "t-error": defineAsyncComponent(() => import("@/components/05-templates/t-error.vue")),
};

const newSlug = props.slug === "/" ? `/${prebuildConfig.root_page_slug}` : props.slug;
const storyblokApi = useStoryblokApi();

const router = useRouter();
const res = await storyblokApi
  .get(`cdn/stories/${newSlug}`, {
    version: import.meta.env.VITE_STORYBLOK_VERSION,
    cv: getCv,
    resolve_relations: prebuildConfig.resolve_relations,
  })
  .catch((e) => {
    // render error page
    const errorSeo = {
      title: "Page not found - Isabella Capobianco",
      description: "Page not found",
    };
    return {
      data: {
        story: {
          content: {
            component: "t-error",
            seo: [{ seo: errorSeo }],
          },
        },
      },
      error: e.response.status,
    };
  });

const data = res?.data;
const error = res?.error;

const state = reactive({ story: data.story });

const { setGlobal } = useSetGlobals();
setGlobal();

// let lastScrollTop = 0;
// const throttledFn = useThrottleFn(() => {
//   var st = window.pageYOffset || document.documentElement.scrollTop;
//   if (st > lastScrollTop && st > 300) {
//     document.body.classList.add("--down");
//     document.body.classList.remove("--up");
//   } else {
//     document.body.classList.add("--up");
//     document.body.classList.remove("--down");
//   }
//   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
// }, 100);
onMounted(() => {
  if (import.meta.env.VITE_IS_EDITOR === "true" && !error) {
    useStoryblokBridge(state.story.id, (story) => (state.story = story), {
      resolveRelations: prebuildConfig.resolve_relations,
    });
  }
});
</script>
